"use client";

import React, { useState, useEffect } from "react";
import ThankYouModal from "../thank-you";
import StepIndicator from "./step-indicator";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";

interface CleaningFormProps {
    lang: string;
    id?: string;
}

const MoveaboardForm: React.FC<CleaningFormProps> = ({ lang }) => {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        moveType: "",
        date: null as Date | null,
        selectOption: "",
        movingFrom: "",
        squareMetersFrom: "",
        floorFrom: "",
        elevatorFrom: "",
        movingTo: "",
        squareMetersTo: "",
        floorTo: "",
        elevatorTo: "",
        fullName: "",
        phone: "",
        email: "",
        comments: "",
        consent: false,
    });

    const [showModal, setShowModal] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // Функция для прокрутки к шагу с offset (как в первой форме)
    const scrollToStep = (stepNumber: number) => {
        setTimeout(() => {
            const element = document.getElementById(`step-${stepNumber}`);
            if (element) {
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - 150;
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }, 100);
    };

    const nextStep = (data: Partial<typeof formData>) => {
        setFormData((prev) => ({ ...prev, ...data }));
        const nextStepNumber = step + 1;
        setStep(nextStepNumber);
        
        // Прокручиваем к следующему шагу после обновления состояния
        setTimeout(() => scrollToStep(nextStepNumber), 150);
    };

    const prevStep = () => {
        const prevStepNumber = step - 1;
        setStep(prevStepNumber);
        
        // Прокручиваем к предыдущему шагу после обновления состояния
        setTimeout(() => scrollToStep(prevStepNumber), 150);
    };

    const submitForm = async (data: Partial<typeof formData>) => {
        const finalData = { ...formData, ...data };

        setIsLoading(true);
      
        try {
          const response = await fetch('/api/send-email', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              formType: 'moveaboard-request', // Новый тип формы
              formData: finalData
            }),
          });
      
          const result = await response.json();
      
          if (!response.ok || !result.success) {
            throw new Error('Failed to submit form');
          }
      
          // Показываем модальное окно успеха
          setShowModal(true);
          setTimeout(() => setIsVisible(true), 50);
      
          // Автоматическое закрытие через 5 секунд (исправлено с 5000000)
          setTimeout(() => {
            setIsVisible(false);
            setTimeout(() => {
              setShowModal(false);
              window.location.href = "/";
            }, 500);
          }, 5000);
      
        } catch (error) {
          console.error('Form submission error:', error);
          // Здесь можно добавить обработку ошибки
        } finally {
          setIsLoading(false); 
        }
      };

    return (
        <>
            <StepIndicator step={step} />
            {step === 1 && (
                <Step1 
                    id="step-1"
                    onNext={nextStep} 
                    initialData={formData}  
                    lang={lang}
                />
            )}
            {step === 2 && (
                <Step2 
                    id="step-2"
                    onNext={nextStep} 
                    onPrev={prevStep} 
                    initialData={formData}  
                    lang={lang}
                />
            )}
            {step === 3 && (
                <Step3 
                    id="step-3"
                    onSubmit={submitForm} 
                    onPrev={prevStep} 
                    initialData={formData} 
                    isLoading={isLoading} 
                    lang={lang}
                />
            )}
            {showModal && (
                <div
                    className={`fixed inset-0 flex items-center justify-center bg-[#00000080] z-10 transition-opacity duration-500 ease-in-out 
                            ${isVisible ? "opacity-100" : "opacity-0 pointer-events-none"}`}
                    onClick={() => {
                        setIsVisible(false);
                        setTimeout(() => setShowModal(false), 500);
                    }}
                >
                    <div
                        className={`transform fixed transition-transform duration-500 ease-in-out
                                ${isVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <ThankYouModal
                            title={lang === "en" ? "Thank you!" : "Tack!"}
                            text={lang === "en" ? "Your price quote request has been submitted. We will contact you very soon." : "Din offertförfrågan har skickats in. Vi kontaktar dig inom kort."}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default MoveaboardForm;